import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { UiTextField, UiIcon, UiLabel } from 'ui-components';
import { useRouter } from 'hooks';
import { getCurrentSlice } from 'utils';
import { StyledPhrasesFilter } from './PhrasesFilter.styles';

export const PhrasesFilter = (props) => {
  const { componentName, parentPlatform, className } = props;
  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds, warningLabel } = filter;
  const dispatch = useDispatch();
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);
  const { clearRouterFilters } = useRouter();
  const [currentWord, setCurrentWord] = useState('');
  const { t } = useTranslation();

  const handleSelectItem = (word) => {
    dispatch(
      setSelectedFilterIds({
        id: word,
        componentName,
        parentPlatform,
      })
    );
    setCurrentWord('');
    clearRouterFilters();
  };

  const handleRemoveSelectedItem = (word) => {
    dispatch(
      setSelectedFilterIds({
        id: word,
        componentName,
        parentPlatform,
      })
    );
    clearRouterFilters();
  };

  const handleChange = (e) => {
    if (!e?.target?.value?.includes('\n')) setCurrentWord(e.target.value);
  };

  return (
    <StyledPhrasesFilter>
      {warningLabel && (
        <UiLabel size={10} color='#F16063'>
          {t(warningLabel)}
        </UiLabel>
      )}
      <div className={classNames('phrases-filter', className)}>
        <UiTextField
          value={currentWord}
          onChange={handleChange}
          placeholder={t('content:enterPhraseName', {
            type:
              componentName === 'wordCloudFilter'
                ? t('content:word')
                : t('content:hashtag'),
          })}
          data-testid='phrases-filter-label'
          InputProps={{
            'data-testid': 'phrases-filter-input',
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSelectItem(e.target.value);
            }
          }}
        />
        {selectedIds.length > 0 && (
          <div className='selected-items'>
            {selectedIds?.map((item) => (
              <div key={item} className='item flex'>
                <span>{item}</span>
                <UiIcon
                  className='item-icon mr-8'
                  icon='ri-close-line'
                  onClick={() => handleRemoveSelectedItem(item)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </StyledPhrasesFilter>
  );
};

PhrasesFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
